const getGlobalState = (state, key) => (Array.isArray(state.events[key]) ? state.events[key].slice(0) : state.events[key]);

export const getEvents = (state) => getGlobalState(state, 'events');
export const getTennisEvents = (state) => getGlobalState(state, 'tennisEvents');
export const getTimeHeaders = (state) => getGlobalState(state, 'timeHeaders');
export const getLastEventId = (state) => getGlobalState(state, 'lastEventId');
export const getLastDate = (state) => getGlobalState(state, 'lastDate');
export const getTennisLastEventId = (state) => getGlobalState(state, 'tennisLastEventId');
export const getTennisLastDate = (state) => getGlobalState(state, 'tennisLastDate');
export const getTennisTimeHeaders = (state) => getGlobalState(state, 'tennisTimeHeaders');

